import React, { useEffect } from 'react';
import { useAdminLoginModal } from '../context/AdminLoginModalContext';
import AdminLoginForm from './AdminLoginForm';

export default function AdminLoginModal() {
  const { isOpen, closeAdminLogin } = useAdminLoginModal();

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    const onKeyDown = e => { if (e.key === 'Escape') closeAdminLogin(); };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={closeAdminLogin}>
      <div className="modal-card auth-card" onClick={e => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={closeAdminLogin} aria-label="Close admin login">✕</button>
        <AdminLoginForm onSuccess={closeAdminLogin} />
      </div>
    </div>
  );
}
